export default __webpack_public_path__ + "static/media/G_D_btn_shopper.41ebef3b.svg";